import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Accordion = ({ title, id, children, extraClassContainer, extraClassPanelContent, onToggle }) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <div className={`accordion ${extraClassContainer}`} id="is24">
      <div>
        <button
          type="button"
          className="align-left font-regular one-whole link-text accordion-header"
          aria-expanded={expanded}
          aria-controls={`is24-accordion-section-${id}`}
          id={`is24-accordion-label-${id}`}
          tabIndex={0}
          onClick={() => {
            setExpanded(!expanded);
            setTimeout(() => {
              onToggle();
            }, 500);
            setTimeout(() => {
              onToggle();
            }, 250);
          }}
        >
          <span>{title}</span>
          <span className={`is24-icon-chevron-down accordion-icon ${expanded ? 'expanded' : ''}`} aria-hidden="true" />
        </button>
      </div>

      <div
        role="region"
        aria-labelledby={`is24-accordion-label-${id}`}
        id={`is24-accordion-section-${id}`}
        className={`accordion-panel ${expanded ? 'expanded' : ''}`}
      >
        <div className={extraClassPanelContent}>{children}</div>
      </div>
    </div>
  );
};

Accordion.propTypes = {
  onToggle: PropTypes.func,
  title: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  extraClassContainer: PropTypes.string,
  extraClassPanelContent: PropTypes.string,
};

Accordion.defaultProps = {
  onToggle: () => {},
  extraClassContainer: '',
  extraClassPanelContent: '',
};

export default Accordion;
